function BracketView({ matches }) {
  if (matches.length === 0) return null;

  const rounds = [...new Set(matches.map((match) => match.round))].sort((a, b) => a - b);

  return (
    <div className="bracket">
      {rounds.map((round) => (
        <div key={round} className="bracket-round">
          <h3>Round {round}</h3>
          <ul>
            {matches
              .filter((match) => match.round === round)
              .map((match) => (
                <li key={match.id}>
                  {match.isBye ? (
                    <span>{match.player1Name} advances (bye)</span>
                  ) : (
                    <span>
                      {match.player1Name} vs {match.player2Name}
                      {match.status === 'complete' ? ` — ${match.winnerName} wins` : ' — in progress'}
                    </span>
                  )}
                </li>
              ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default BracketView;
